import React, { useEffect, useRef, useState } from "react";// Add to imports
import { Box, Container, IconButton, List, ListItem, ListItemText, Paper, Tooltip } from '@mui/material';// Material ui
import AvatarFemale from "./image/English.png";
import AvatarMale from "./image/Chinese.png";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import PauseIcon from '@mui/icons-material/Pause';
import FileCopyIcon from '@mui/icons-material/FileCopy'; // added by nelson for copy icon
import { useTheme } from '@mui/material/styles';
import HearingIcon from '@mui/icons-material/Hearing';
import Avatar from '@mui/material/Avatar';
import './App.css';
import './Zero.css';
import TopicsUtil from "./TopicsUtil";
// import topics_en from './topics_en.json';
// import topics_cn from './topics_cn.json';
// import topics_en_vn from './topics_en_vn.json';
// import topics_cn_vn from './topics_cn_vn.json';
import { AudioControls } from './UtilsAudioControls'
import { MessageInput, ThinkingBubble, ChatFooter, UserMessage, MessageWrapper } from './UtilsMisc'
import { useParams } from 'react-router-dom'; // to process the path value from url
import TranslateIcon from "@mui/icons-material/Translate";
import RefreshIcon from '@mui/icons-material/Refresh';
import EditIcon from '@mui/icons-material/Edit';
import { v4 as uuidv4 } from 'uuid';
import { useCookies } from 'react-cookie';

function App() {

  const [isAudioResponse, setIsAudioResponse] = useState(true);
  const [message, setMessage] = useState("");
  const theme = useTheme();
  const [thinking, setThinking] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [defaultSpeed, setDefaultSpeed] = useState(0.8);
  const [player, setPlayer] = useState(null);
  const [audioFile] = useState(null);

  const [messages, setMessages] = useState([]);
  const [refMessages, setRefMessages] = useState([]);
  const params = useParams();
  const { learnLanguage: urlLearnLanguage, nativeLanguage: urlNativeLanguage } = params; // Rename variables to avoid conflicts

  const [learnLanguage, setLearnLanguage] = useState(''); // State variable for learnLanguage
  const [nativeLanguage, setNativeLanguage] = useState(''); // State variable for nativeLanguage


  const [selectedLevel, setSelectedLevel] = useState('beginner');
  const [selectedTopic, setSelectedTopic] = useState('Anything');
  const [topics, setTopics] = useState({});
  const [cookie, setCookie] = useCookies(["sessionId", "chatId"]);
  const [countRefMessages, setCountRefMessages] = useState(0);

  const selected_levels = {
    "English": ["beginner", "Anything"],
    "Chinese": ["HSK1", "任意话题"]
  };
  const assistant_contents = {
    "English": "I'm Rachel. Could you chat with me?",
    "Chinese": "我是小明。我们聊天好吗？"
  };

  useEffect(() => {

    let sessionId = cookie["sessionId"];
    if (sessionId === undefined) {
      sessionId = uuidv4();
      setCookie("sessionId", sessionId);
    }
    console.log("sessionId: " + sessionId);

    if (typeof learnLanguage === 'string' && typeof nativeLanguage === 'string') {
      setLearnLanguage(urlLearnLanguage);
      setNativeLanguage(urlNativeLanguage);
      setSelectedLevel(selected_levels[urlLearnLanguage][0]);
      setSelectedTopic(selected_levels[urlLearnLanguage][1]);
      TopicsUtil.getTopics(urlLearnLanguage, urlNativeLanguage, setTopics);
    }
    let student_id, student_name;
    if (params.hasOwnProperty('student_id') && typeof params.student_id === 'string') {
      student_id = params.student_id;
      student_name = student_id.split("_")[0];
      console.log("student_id " + student_id);
    } else {
      console.log('invalid student_id');
      return;
    }

    const mockMessage = {
      role: 'assistant',
      content: 'Hi ' + student_name + ', ' + assistant_contents[urlLearnLanguage],
      text: 'Hi ' + student_name + ', ' + assistant_contents[urlLearnLanguage],
      language: urlLearnLanguage,
      ref_id: countRefMessages
    };
    console.log('initialize mockmessage language', mockMessage.language);
    const mockMessages = [mockMessage];
    setMessages(mockMessages);
    setRefMessages(mockMessages);
    setCountRefMessages(countRefMessages + 1);
  }, [urlLearnLanguage]);


  const AudioMessage = ({ messageElement }) => {
    const handleChangeAudioSpeed = (speed) => {
      if (messageElement.audio) {
        if (messageElement.audio.paused) {
          messageElement.audio.playbackRate = speed;
          setDefaultSpeed(speed);
        } else {
          messageElement.audio.pause();
          messageElement.audio.currentTime = 0;
          setTimeout(() => {
            messageElement.audio.playbackRate = speed;
            setDefaultSpeed(speed);

          }, 100);
          messageElement.audio.play();
        }
      } else {
        // console.log('no audio element in handle change element speed');
      }
    };

    //AI reply buttons, playbutton, pausebutton,playbackspeed,copy.
    return (
      <span>
        {messageElement.audio ? (
          <>
            <IconButton
              aria-label="play-message"
              onClick={() => {
                messageElement.audio.play();
              }}
            >
              <Tooltip title={nativeLanguage === "Chinese" ? "播放" : nativeLanguage === "Vietnamese" ? "Phát tin nhắn" : "Play message"}>
                <VolumeUpIcon style={{ cursor: "pointer" }} fontSize="small" />
              </Tooltip>
            </IconButton>
            <Tooltip title={nativeLanguage === "Chinese" ? "暂停" : nativeLanguage === "Vietnamese" ? "Tạm ngừng" : "Pause"}>
              <IconButton
                aria-label="pause-message"
                onClick={() => {
                  messageElement.audio.pause();
                }}
              >
                <PauseIcon style={{ cursor: "pointer" }} fontSize="small" />
              </IconButton>
            </Tooltip>
            <select id="select-element-speed" value={messageElement.audio.playbackRate}
              onChange={(e) =>
                handleChangeAudioSpeed(parseFloat(e.target.value))
              }>
              <option value={messageElement.audio.playbackRate}>{messageElement.audio.playbackRate}x</option>
              <option key="1" value="0.7">0.7x</option>
              <option key="2" value="0.8">0.8x</option>
              <option key="3" value="0.9">0.9x</option>
              <option key="4" value="1.0">1.0x</option>
              <option key="5" value="1.5">1.5x</option>
            </select>
          </>
        ) : (
          <IconButton
            aria-label="play-message"
            onClick={() => {
              handleSendMessage("4", undefined, undefined, messageElement, topics);
            }}
          >
            <Tooltip title={nativeLanguage === "Chinese" ? "获取配音" : nativeLanguage === "Vietnamese" ? "Yêu cầu âm thanh" : "Request audio"}>
              <HearingIcon style={{ cursor: "pointer" }} fontSize="small" />
            </Tooltip>
          </IconButton>
        )
        }
        <IconButton
          aria-label="copy-message"
          onClick={() => {
            setMessage(messageElement.text);
          }}
        >
          <Tooltip title={nativeLanguage === "Chinese" ? "复制消息" : nativeLanguage === "Vietnamese" ? "Sao chép tin nhắn" : "Copy message"}>
            <FileCopyIcon style={{ cursor: "pointer" }} fontSize="small" />
          </Tooltip>
        </IconButton>
        <IconButton
          aria-label="translate-message"
          onClick={() => {
            handleSendMessage("2", "translateToNative1", null, null, messageElement.text, topics);
          }}
        >
          <Tooltip title={nativeLanguage === "Chinese" ? "翻译消息" : nativeLanguage === "Vietnamese" ? "Dịch tin nhắn" : "Translate message"}>
            <TranslateIcon style={{ cursor: "pointer" }} fontSize="small" />
          </Tooltip>
        </IconButton>
      </span >
    )
  };

  const ChatMessages = ({ messages }) => {
    const theme = useTheme();
    const bottomRef = useRef(null);

    const scrollToBottom = () => {
      if (bottomRef.current) {
        if (typeof bottomRef.current.scrollIntoViewIfNeeded === 'function') {
          bottomRef.current.scrollIntoViewIfNeeded({ behavior: 'smooth' });
        } else {
          bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };
    // adding avatar icon for ai reply
    const AgentMessage = ({ theme, children, messageLanguage }) => {
      let avatarSrc;

      if ((messageLanguage === 'Chinese')
        || (!messageLanguage && learnLanguage === 'Chinese')) {
        // console.log('AgentMessage messageLanguage chinese found ' + messageLanguage)
        avatarSrc = AvatarMale; // Male avatar if messasge is Chinese or very likely Chinese
      } else {
        // console.log('AgentMessage messageLanguage not chinese, is' + messageLanguage)
        avatarSrc = AvatarFemale; // Female avatar for other cases
      }

      return (
        <div className="agent-message-wrapper"> 
          {avatarSrc && (
            <Avatar src={avatarSrc} alt={`${messageLanguage === 'Chinese' ? 'Chinese' : 'English'} AI Icon`} style={{ width: '35px', height: '35px', marginRight: '8px', marginTop: '5px' }} />
          )}
          <div>{children}</div>
        </div>
      );
    };

    // Hook that scrolls the chat to the bottom whenever the messages prop changes
    useEffect(() => {
      scrollToBottom();
    }, [messages]);

    // user audio play and pause button. 
    // user chat copy button.
    return (
      <Container>
        <Box sx={{ width: '110%', mt: -1, mb: 1, ml: -3, maxHeight: 380, minHeight: 380, overflow: 'auto' }}>
          <Paper elevation={0} sx={{ padding: 0, backgroundColor: 'rgba(230, 197, 151, 0.4)' }} >
            <List>
              {messages.map((messageElement, index) => (
                <ListItem key={index} sx={{ padding: 0 }}>

                  <ListItemText
                    sx={{ margin: 0 }}
                    primary={
                      <MessageWrapper align={messageElement.role} sx={{ paddingLeft: '5px', maxWidth: '95%' }}>
                        {messageElement.role === 'user' ? (
                          <>
                            <UserMessage theme={theme} audio={messageElement.audio} sx={{ marginLeft: '10px', maxWidth: '50%' }}>
                              {messageElement.text}
                              {messageElement.audio ? (
                                <>
                                  <IconButton
                                    size="small"
                                    aria-label="play-message"
                                    onClick={() => messageElement.audio.play()}
                                  >
                                    <Tooltip title={nativeLanguage === "Chinese" ? "播放留言" : nativeLanguage === "Vietnamese" ? "Phát tin nhắn" : "Play message"}>
                                      <VolumeUpIcon fontSize="small" />
                                    </Tooltip>
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    aria-label="pause-message"
                                    onClick={() => { messageElement.audio.pause(); }}
                                  >
                                    <Tooltip title={nativeLanguage === "Chinese" ? "暂停" : nativeLanguage === "Vietnamese" ? "Tạm ngừng" : "Pause"}>
                                      <PauseIcon style={{ cursor: "pointer" }} fontSize="small" />
                                    </Tooltip>
                                  </IconButton>
                                  <IconButton
                                    aria-label="reload-message"
                                    onClick={() => {
                                      handleSendMessage("3", "resubmit_audio", messageElement.base64Audio);
                                    }}
                                  >
                                    <Tooltip title={nativeLanguage === "Chinese" ? "重新发送音频" : nativeLanguage === "Vietnamese" ? "Gửi lại âm thanh" : "Resend audio"}>
                                      <RefreshIcon style={{ cursor: "pointer" }} fontSize="small" />
                                    </Tooltip>
                                  </IconButton>
                                </>
                              ) : (
                                <>
                                  <IconButton
                                    size="small"
                                    aria-label="copy-message"
                                    onClick={() => { setMessage(messageElement.text); }}
                                  >
                                    <Tooltip title={nativeLanguage === "Chinese" ? "复制消息" : nativeLanguage === "Vietnamese" ? "Sao chép tin nhắn" : "Copy message"}>
                                      <FileCopyIcon style={{ cursor: "pointer" }} fontSize="small" />
                                    </Tooltip>
                                  </IconButton>
                                  {(messageElement.handle_type === '1' && (
                                    <IconButton
                                      size="small"
                                      aria-label="copy-message"
                                      onClick={() => {
                                        setMessage(messageElement.text);
                                        // deleteRefMessages(messageElement.ref_id);
                                        console.log('messageElement.ref_id ' + messageElement.ref_id)
                                        setRefMessages(refMessages => refMessages.filter(item => item.ref_id < messageElement.ref_id))
                                      }}
                                    >
                                      <Tooltip title={nativeLanguage === "Chinese" ? "编辑消息" : nativeLanguage === "Vietnamese" ? "Chỉnh sửa tin nhắn" : "Edit message"}>
                                        <EditIcon style={{ cursor: "pointer" }} fontSize="small" />
                                      </Tooltip>
                                    </IconButton>)
                                  )}

                                </>
                              )
                              }
                            </UserMessage>

                          </>
                        ) : messageElement.role === 'system' ? (
                          null
                        ) : (
                          <AgentMessage theme={theme} messageLanguage={messageElement.language}>
                            <div>

                              {(typeof messageElement.text === 'string'
                                && messageElement.text.includes('\n')) && (
                                  <>
                                    {messageElement.text.split('\n').map((line, lineIndex) => (

                                      <React.Fragment key={lineIndex}>
                                        {line}
                                        <br />
                                      </React.Fragment>
                                    ))}
                                    {(messageElement.key !== "thinking" && <AudioMessage messageElement={messageElement} />)}
                                  </>
                                )}
                              {(typeof messageElement.text === 'string'
                                && !messageElement.text.includes('\n')) && (
                                  <>
                                    {messageElement.text}
                                    {' '}
                                    {messageElement.key !== "thinking" && <AudioMessage messageElement={messageElement} />}
                                  </>
                                )}
                              {/* Add a condition to display the "thinking" bubble */}
                              {messageElement.key === "thinking" && (<ThinkingBubble />)}
                            </div>
                          </AgentMessage>
                        )}
                      </MessageWrapper>
                    }
                  />
                </ListItem>
              ))}
              <div ref={bottomRef} />
            </List>
          </Paper>
        </Box>
      </Container>
    )

  }

  function filterMessageObjects(list) { // not only to filter text and audio, but also to clone the list
    let newList = list.map(({ role, content }) => ({ role, content }));
    return newList;
  }

  //cancel sending
  const handleCancelSending = async () => {
    // console.log('cancelSending')
    setThinking(false);
    setIsRecording(false);
    setMessages((prevMessages) => {
      return prevMessages.filter((prevMessageElement) => prevMessageElement.key !== "thinking");
    });
    alert('try again in 2 seconds.');
  }


  const handleSendMessage = async (handle_type = "1", messageType = "", base64Audio = null, messageElement = null, messageToHandle = "") => {
    //console.log('handleSendMessage handle_type ' + handle_type);
    // handle_type: 1 chat, 2 assist, 3 transcribe, 4 get audio, 5 suggest sentence

    // check url first, if no chat_id, return
    // if (
    //   (params.hasOwnProperty('learnLanguage') && typeof params.learnLanguage === 'string')
    //   && (params.hasOwnProperty('nativeLanguage') && typeof params.nativeLanguage === 'string')
    //   && (params.hasOwnProperty('chat_id') && typeof params.chat_id === 'string')) {
    //     learnLanguage = params.learnLanguage.toLowerCase();
    //     nativeLanguage = params.nativeLanguage.toLowerCase();
    //     chat_id = params.chat_id;
    //     console.log("chat_id " + chat_id);
    // } 
    let chat_id, student_id, student_name;
    if (params.hasOwnProperty('chat_id') && typeof params.chat_id === 'string') {
      chat_id = params.chat_id;
      //console.log("chat_id " + chat_id);
    } else {
      //console.log('invalid chat_id');
      return;
    }

    if (params.hasOwnProperty('student_id') && typeof params.student_id === 'string') {
      student_id = params.student_id;
      student_name = student_id.split("_")[0];
      console.log("student_id " + student_id);
    } else {
      console.log('invalid student_id');
      return;
    }
    let message2 = message;
    if (messageType === "translateToNative1") {// click translateButton in message
      //console.log("translateToNative1");
      message2 = messageToHandle;
    }
    let text2 = message;
    let newAudio = null;
    let newBase64Audio = null;
    let messageLanguage = learnLanguage;
    let replyLanguage = learnLanguage;


    if (handle_type === "2" && message.trim() !== "") {
      if (messageType === "translateToNative") {
        // console.log('message2 is ' + message2)
        text2 = `{ ${message} } Translate to ${nativeLanguage}`;
        replyLanguage = nativeLanguage;
        //console.log('translate to ' + nativeLanguage);
      } else if (messageType === "translateToLearn") {
        text2 = `{ ${message} } Translate to ${learnLanguage}`;
        replyLanguage = learnLanguage;
      } else if (messageType === "ExampleInput") {

        text2 = `{ ${message} } Explain this sentence.`;
      } else if (messageType === "MakeSentenceInput") {
        text2 = `Make 2 sentences with { ${message} } .`;
      } else if (messageType === "CheckInput") {
        text2 = `{ ${message} } Check grammar and words.`;
      }
    } else if (handle_type === "3") {
      text2 = "🎤 Audio Message";
      newAudio = new Audio(base64Audio);
      newBase64Audio = base64Audio;
    }
    let sentences = {}
    // Add the new message to the chat area
    if (handle_type === "5") {
      // send useful sentences to the chat box
      // let use_topics;
      // if (learnLanguage === 'Chinese') {
      //   if (nativeLanguage === 'Vietnamese') {
      //     use_topics = topics_cn_vn;
      //   } else {
      //     use_topics = topics_cn;
      //   }
      // } else {
      //   if (nativeLanguage === 'Vietnamese') {
      //     use_topics = topics_en_vn;
      //   } else {
      //     use_topics = topics_en;
      //   }
      // }
      console.log("handle: " + JSON.stringify(topics))
      if (JSON.stringify(topics) === "{}") {
        return;
      }
      sentences = topics[selectedLevel][1][selectedTopic];

      let sentenceMessages = sentences.map(sentence => ({
        role: "assistant",
        content: sentence,
        text: sentence,
        language: messageLanguage
      }));
      //console.log(sentenceMessages);
      setMessages((prevMessages) => [
        ...prevMessages,
        ...sentenceMessages,
      ]);
      return;
    } else if (handle_type !== "4") { // handle_type 4 is to request audio for a message, don't add new message
      let new_message = {
        role: "user",
        content: message2,
        text: text2,
        audio: newAudio,
        base64Audio: newBase64Audio,
        language: messageLanguage,
        ref_id: countRefMessages,
        handle_type: handle_type
      };
      if (handle_type === "3" && messageType === "resubmit_audio") {
      }
      else if (messageType === "translateToNative1") {
        replyLanguage = nativeLanguage;
      }
      else
        setMessages((prevMessages) => [
          ...prevMessages,
          new_message
        ]);


    }

    if (handle_type === "1") { // only handle type 1 need to update refMessages
      if (refMessages.length % 2 === 0) {//for baidu
        //console.log('refMessages.length is even ' + refMessages.length);
        setRefMessages((prevRefMessages) => [
          ...prevRefMessages,
          { role: "assistant", content: "...", text: "...", audio: null, ref_id: countRefMessages },
        ]);
      }
      // if (refMessages.length > 13) { // keep first 2 (0-3) and last 3.5 (6-12) rounds of messages (delete 4-5)
      //   //console.log('refMessages.length > 13, is ' + refMessages.length);
      //   setRefMessages((prevRefMessages) => [
      //     ...prevRefMessages.slice(0, 4).concat(prevRefMessages.slice(6)),
      //     { role: "user", content: message2, text: text2, audio: null },
      //   ]);
      // } 

      let max_length = 13
      if (selectedTopic == '0. Story tell') {
        max_length = 29
      }
      if (refMessages.length > max_length) { // keep last 4.5 (2-10) rounds of messages (delete 4-5)
        //console.log('refMessages.length > 11, is ' + refMessages.length);
        setRefMessages((prevRefMessages) => [
          ...prevRefMessages.slice(4),
          { role: "user", content: message2, text: text2, audio: null, ref_id: countRefMessages },
        ]);
      } else {
        console.log('refMessages.length ' + refMessages.length);
        setRefMessages((prevRefMessages) => [
          ...prevRefMessages,
          { role: "user", content: message2, text: text2, audio: null, ref_id: countRefMessages },
        ]);
      }
      setCountRefMessages(countRefMessages + 1);
      console.log('list ref messages id and text');
      refMessages.forEach(
        messageElement => console.log(messageElement.ref_id + ' ' + messageElement.content)
      );
    }


    setMessage(""); // Clear the input field

    // Create backend chat input
    let messageObjects = filterMessageObjects(refMessages); // new user message not in this refMessages yet
    //console.log('messageObjects ' + messageObjects);
    //console.log('new user message ' + message2);
    let bodyMsg = {
      text: text2,
      messages: messageObjects,
      isAudioResponse,
      handle_type: handle_type,
      message2: message2, //send new message to backend to add to message_objects
      selected_level: selectedLevel,
      selected_topic: selectedTopic,
      chat_id: chat_id,
      student_id: student_id,
      student_name: student_name,
      learn_language: learnLanguage,
      native_language: nativeLanguage,
      session_id: cookie["sessionId"]
    };

    if (handle_type === "2") {
      bodyMsg.message_type = messageType;
    } else if (handle_type === "3") {
      bodyMsg.audio = base64Audio;
    } else if (handle_type === "4") {
      bodyMsg.text = messageElement.text;
      //console.log('get audio for which language ' + messageElement.language);
      if (messageElement.language === "Chinese") {
        //console.log('read cn message');
        bodyMsg.target_language = "Chinese";
      }
    }
    // Create endpoint for just getting the completion
    try {

      // console.log('messageObjects: ');
      // messageObjects.forEach(messageElement => {
      //   console.log(messageElement.content);
      // });
      // console.log('end of messageObjects');

      // Add thinking bubble
      setThinking(true);
      setMessages((prevMessages) => [
        ...prevMessages,
        { role: "assistant", content: <ThinkingBubble theme={theme} sx={{ marginBottom: '-5px' }} />, text: <ThinkingBubble theme={theme} sx={{ marginBottom: '-5px' }} />, key: "thinking" },
      ]);

      //console.log('test fastapi');
      const apiUrl = "/handler";
      //const apiUrl = "http://127.0.0.1:8000/handler"; //local testing
      // const apiUrl = "https://17talk.xyz:8443/handler"; // server testing 
      // const apiUrl = "https://17talk.xyz/handler"; // production
      // console.log('test server url ' + apiUrl);

      // Create an AbortController instance
      const controller = new AbortController();
      const signal = controller.signal;
      const fetchTimeoutId = setTimeout(() => {
        controller.abort(); // Abort the fetch request when the timeout is reached
        handleCancelSending();
      }, 32000); // 32000, 1000 = 1 second, 25s in openai or ernie, 7s for audio and network latency

      // Send the text message to the backend
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyMsg),
        signal,
      };

      fetch(apiUrl, requestOptions)
        .then((api_response) => api_response.json())
        .then((data) => {
          //console.log('got data');
          clearTimeout(fetchTimeoutId); // got data, so clear timeout
          // Handle the response data here
          let response = JSON.parse(data.body)
          if (handle_type === "3") {
            setMessage(response.transcription);
          } else {
            handleBackendResponse(response, messageElement, handle_type, replyLanguage);
          }
          // Remove the thinking bubble
          setThinking(false);
          setMessages((prevMessages) => {
            return prevMessages.filter((prevMessageElement) => prevMessageElement.key !== "thinking");
          });
        })
        .catch((error) => {
          clearTimeout(fetchTimeoutId); // got error reply from server, so clear timeout
          //console.log('got error in fetch')
          // console.error(error);
        });

      if (handle_type !== "4") { //require audio, shouldn't move cursor
        //console.log('move cursor')
        if (window.screen.width > 768) {
          let inputElement = document.getElementById("inputBox");
          inputElement.focus();
        }
      }

    } catch (error) {
      //console.log("Error sending message to ai");
    }

  };


  const handleBackendResponse = (response, messageElement = null, handle_type = "1", replyLanguage = { learnLanguage }) => {
    const generatedText = response.generated_text;
    //console.log('generatedText ' + generatedText);
    const generatedAudio = response.generated_audio;

    const audioElement = ((generatedAudio && generatedAudio.length) > 1000) // usually 244 or 300 if broken
      ? new Audio(`data:audio/mpeg;base64,${generatedAudio}`)
      : null;

    if (audioElement) {
      audioElement.playbackRate = defaultSpeed;
      audioElement.play();
    } else {
      //console.log('no audio element from backend');
    }

    // Simply add the response when no messageId is involved
    if (handle_type === "4") {
      if (audioElement) {
        messageElement.audio = audioElement;
        //console.log('got audio');
      } else {
        alert('网络拥堵，请稍后再试。');
        //console.log('did not get audio');
      }
      return;
    } else {
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          role: "assistant",
          content: generatedText,
          audio: audioElement,
          text: generatedText,
          language: replyLanguage,
          ref_id: countRefMessages
        },
      ]);
    }
    if (handle_type === "1") { // ONLY save chat messages
      console.log('saving backEndResponse handle_type === 1');
      setRefMessages((prevRefMessages) => [
        ...prevRefMessages,
        {
          role: "assistant",
          content: generatedText,
          audio: audioElement,
          ref_id: countRefMessages
        },
      ]);
      // setCountRefMessages(countRefMessages+1); // response use same ref_id as sent refMessage
      console.log('list ref messages id and text with handdleResponse');
      refMessages.forEach(
        messageElement => console.log(messageElement.ref_id + ' ' + messageElement.content)
      );
    }
    setMessage("");
  }
  if (JSON.stringify(topics) === "{}") {
    TopicsUtil.getTopics(learnLanguage, nativeLanguage, setTopics);
    return;
  }
  return (
    <div className="App1">
      <div className="backgroundImage"></div>
      <Container maxWidth="sm" sx={{ pt: 2, mx: "auto", }}>
        <ChatMessages messages={messages} />
        <AudioControls
          isRecording={isRecording}
          setIsRecording={setIsRecording}
          isAudioResponse={isAudioResponse}
          setIsAudioResponse={setIsAudioResponse}
          filterMessageObjects={filterMessageObjects}
          message={message}
          setMessage={setMessage}
          messages={messages}
          setMessages={setMessages}
          handleSendMessage={handleSendMessage}
          thinking={thinking}
          setThinking={setThinking}
          refMessages={refMessages}
          setRefMessages={setRefMessages}
          selectedLevel={selectedLevel}
          setSelectedLevel={setSelectedLevel}
          selectedTopic={selectedTopic}
          setSelectedTopic={setSelectedTopic}
          defaultSpeed={defaultSpeed}
          player={player}
          setPlayer={setPlayer}
          audioFile={audioFile}
          learnLanguage={learnLanguage}
          topics={topics}
          nativeLanguage={nativeLanguage}
        />
        <MessageInput
          isRecording={isRecording}
          setIsRecording={setIsRecording}
          message={message}
          setMessage={setMessage}
          setMessages={setMessages}
          refMessages={refMessages}
          setRefMessages={setRefMessages}
          isAudioResponse={isAudioResponse}
          handleSendMessage={handleSendMessage}
          thinking={thinking}
          setThinking={setThinking}
          learnLanguage={learnLanguage}
          nativeLanguage={nativeLanguage}
        />
        <ChatFooter
          nativeLanguage={nativeLanguage} />
      </Container>
    </div>
  );
}

export default App;